import { useMemo } from 'react';
import { api } from '../../../api';
import { useRestStore } from '../useRestStore';

export const useLegalEntities = financeEntityId => {
    const store = useRestStore(
        ['legalEntities', financeEntityId],
        {
            get: () => api.financeEntities.getDocumentHeads(financeEntityId),
            update: (id, item) => api.documentHeads.update(id, item),
            create: data => api.documentHeads.create(financeEntityId, data),
            delete: id => api.documentHeads.delete(id)
        },
        {
            enabled: !!financeEntityId
        }
    );

    return useMemo(() => {
        return {
            status: store.status,
            legalEntities: store.data,
            updateEntity: store.update,
            getById: store.getById,
            deactivateEntity: id => store.update(id, { is_active: false }),
            activateEntity: id => store.update(id, { is_active: true }),
            createEntity: store.create,
            deleteEntity: store.delete
        };
    }, [store]);
};
